import { Button, Form, Select } from "antd";
import { useEffect, useState } from "react";
import { EkoverifyBank, getEkoBanks } from "../EkoEndpoint";
import CommonInput from "../../../../Common/CommonInput";
import {
  dispatchtoast,
  filterOption,
  getLocalStorageItem,
  ifscPattern,
} from "../../../../Utils";
import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../../Store/B2bslice";

const EkoBankVerification = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const handleGetbank = () => {
    getEkoBanks()
      .then((res) => {
        setBanks(
          res.banks.map((i) => {
            return {
              label: i?.bank_name,
              value: i?.id,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    handleGetbank();
    dispatch(setselectedTab("300.4"));
  }, []);

  const handleVerify = (v) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    Object.keys(v).map((i) => formdata.append(i, v[i]));
    EkoverifyBank(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          form.resetFields();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2"> Bank Verification</p>
          <Form
            name="form"
            form={form}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleVerify(val)}
          >
            <Form.Item
              name={`bank_id`}
              label={"Select Bank"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select One Bank!",
                },
              ]}
            >
              <Select
                showSearch
                filterOption={filterOption}
                placeholder="Select a bank"
                className="w-full mt-2"
                options={banks}
              />
            </Form.Item>
            <Form.Item
              name={`benificiary_ifsc`}
              label={"IFSC"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter IFSC!",
                },
                {
                  pattern: ifscPattern,
                  message: "Enter valid IFSC!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.toUpperCase();
                  e.target.value = value;
                }}
                placeholder="Enter IFSC"
                name="benificiary_ifsc"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`benificiary_account`}
              label={"Account No."}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter account no!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter account No"
                name="amount"
              />
            </Form.Item>
            <Form.Item
              name={`benificiary_name`}
              label={"Benificiary Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Benificiary Name!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Benificiary Name"
                name="benificiary_name"
              />
            </Form.Item>{" "}
            {/* )} */}
            <Button
              loading={btnLoading}
              className="w-full bg-primary border-none mt-4"
              style={{ color: "white" }}
              htmlType="submit"
            >
              Verify
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default EkoBankVerification;
